module.exports = __webpack_public_path__ + "img/equatorialguinea.b3545475.svg";